/**
 * App-Settings Fixture — mirrors Core-Shape exakt.
 * Quelle: lmm-wiki/wiki/orbit-specs/admin-integrations-and-settings-shapes.md#A5
 *
 * Per-Key Shape (Core-Spec):
 *   { key, type, group, label, description, min, max,
 *     isSecret, envDefault, effective, source, updatedAt }
 *
 * Types: 'boolean' | 'integer' | 'string' | 'url'.
 * Groups (fix): "Steuern", "Sicherheit", "Auth-TTLs", "Mail-URLs",
 *               "Payment-URLs", "Mail", "Identity".
 */

function persist() {
  if (typeof window === 'undefined') return null;
  if (!window.__ORBIT_APP_SETTINGS_DB__) {
    window.__ORBIT_APP_SETTINGS_DB__ = {};
  }
  return window.__ORBIT_APP_SETTINGS_DB__;
}

const REGISTRY = [
  // Steuern
  { key: 'OSS_ENABLED', type: 'boolean', group: 'Steuern',
    label: 'OSS-Verfahren aktiv', envDefault: false,
    description: 'Schaltet destination-country-VAT für intra-EU-B2C an.' },
  { key: 'VAT_REVERIFY_ENABLED', type: 'boolean', group: 'Steuern',
    label: 'VAT-Reverify Worker', envDefault: true,
    description: 'Periodische Re-Verifikation von VAT-IDs gegen BZSt.' },
  { key: 'VAT_REVERIFY_AFTER_DAYS', type: 'integer', group: 'Steuern',
    label: 'VAT-Reverify Stale-Threshold', envDefault: 90, min: 7, max: 365 },
  { key: 'VAT_REVERIFY_BATCH_SIZE', type: 'integer', group: 'Steuern',
    label: 'VAT-Reverify Batch-Size', envDefault: 100, min: 1, max: 1000 },
  { key: 'BZST_API_URL', type: 'url', group: 'Steuern',
    label: 'BZSt eVATR-REST-Endpoint',
    envDefault: 'https://api.evatr.vies.bzst.de/app/v1/abfrage' },

  // Sicherheit
  { key: 'HIBP_CHECK_ENABLED', type: 'boolean', group: 'Sicherheit',
    label: 'HIBP Passwort-Check', envDefault: false,
    description: 'k-Anonymity-Check gegen haveibeenpwned.com.' },
  { key: 'HIBP_MIN_OCCURRENCES', type: 'integer', group: 'Sicherheit',
    label: 'HIBP Schwellwert', envDefault: 1, min: 1, max: 1000 },
  { key: 'CLOUDFLARE_ENABLED', type: 'boolean', group: 'Sicherheit',
    label: 'Cloudflare IP-Range-Check', envDefault: true },
  { key: 'CLOUDFLARE_IP_RANGES', type: 'string', group: 'Sicherheit',
    label: 'CSV CIDRs (leer = Defaults)', envDefault: '' },
  { key: 'CLOUDFLARE_ACCESS_TEAM', type: 'string', group: 'Sicherheit',
    label: 'Zero-Trust Team-Slug', envDefault: '' },
  { key: 'CLOUDFLARE_ACCESS_AUD', type: 'string', group: 'Sicherheit',
    label: 'aud-Claim', envDefault: '' },
  { key: 'CANONICAL_HOSTS', type: 'string', group: 'Sicherheit',
    label: 'Host-Header Allowlist', envDefault: 'valitype.com' },
  { key: 'CORS_ALLOWED_ORIGINS', type: 'string', group: 'Sicherheit',
    label: 'CORS Origin-Allowlist',
    envDefault: 'https://orbit.api.valitype.net' },

  // Auth-TTLs
  { key: 'PASSWORD_RESET_TTL_MINUTES', type: 'integer', group: 'Auth-TTLs',
    label: 'Password-Reset TTL (min)', envDefault: 60, min: 5, max: 1440 },
  { key: 'EMAIL_VERIFY_TTL_HOURS', type: 'integer', group: 'Auth-TTLs',
    label: 'Email-Verify TTL (h)', envDefault: 48, min: 1, max: 720 },
  { key: 'SSO_EXCHANGE_TTL_SECONDS', type: 'integer', group: 'Auth-TTLs',
    label: 'SSO-Exchange TTL (s)', envDefault: 120, min: 30, max: 600 },

  // Mail-URLs
  { key: 'PASSWORD_RESET_URL_TEMPLATE', type: 'url', group: 'Mail-URLs',
    label: 'Password-Reset URL-Template',
    envDefault: 'https://{brand}/auth/reset?token={token}',
    description: 'Platzhalter: {token}, {brand}.' },
  { key: 'EMAIL_VERIFY_URL_TEMPLATE', type: 'url', group: 'Mail-URLs',
    label: 'Email-Verify URL-Template',
    envDefault: 'https://{brand}/auth/verify?token={token}' },

  // Payment-URLs
  { key: 'STRIPE_CHECKOUT_SUCCESS_URL', type: 'url', group: 'Payment-URLs',
    label: 'Stripe Success-URL',
    envDefault: 'https://valitype.com/checkout/success' },
  { key: 'STRIPE_CHECKOUT_CANCEL_URL', type: 'url', group: 'Payment-URLs',
    label: 'Stripe Cancel-URL',
    envDefault: 'https://valitype.com/checkout/cancel' },
  { key: 'PAYPAL_RETURN_URL', type: 'url', group: 'Payment-URLs',
    label: 'PayPal Return-URL',
    envDefault: 'https://valitype.com/checkout/return' },
  { key: 'PAYPAL_CANCEL_URL', type: 'url', group: 'Payment-URLs',
    label: 'PayPal Cancel-URL',
    envDefault: 'https://valitype.com/checkout/cancel' },

  // Mail
  { key: 'SMTP_FROM_FALLBACK', type: 'string', group: 'Mail',
    label: 'SMTP Default-From',
    envDefault: 'noreply@valitype.com',
    description: 'Wenn weder tenant_credentials.smtp.fromAddress noch tenants.email_from gesetzt sind.' },

  // Identity
  { key: 'IDENTITY_ZITADEL_ENABLED', type: 'boolean', group: 'Identity',
    label: 'Zitadel-OIDC aktiv', envDefault: false },
  { key: 'IDENTITY_ZITADEL_ISSUER', type: 'url', group: 'Identity',
    label: 'Zitadel Issuer-URL', envDefault: '' },
  { key: 'IDENTITY_ZITADEL_JWKS_URL', type: 'url', group: 'Identity',
    label: 'Zitadel JWKS-URL', envDefault: '' },
  { key: 'IDENTITY_ZITADEL_AUDIENCE', type: 'string', group: 'Identity',
    label: 'Zitadel Audience-Claim', envDefault: '' },
];

export function appSettingsFixture() {
  const db = persist();
  return {
    settings: REGISTRY.map((s) => {
      const hasOverride = db && s.key in db;
      return {
        key: s.key,
        type: s.type,
        group: s.group,
        label: s.label,
        description: s.description ?? null,
        min: s.min ?? null,
        max: s.max ?? null,
        isSecret: !!s.isSecret,
        envDefault: s.envDefault,
        effective: hasOverride ? db[s.key] : s.envDefault,
        source: hasOverride ? 'db' : 'env',
        updatedAt: hasOverride ? new Date().toISOString() : null,
      };
    }),
  };
}

export function applyAppSettingsPatch(patch) {
  const db = persist();
  if (!db) return;
  Object.entries(patch).forEach(([k, v]) => {
    db[k] = v;
  });
}

export function resetAppSetting(key) {
  const db = persist();
  if (!db) return;
  delete db[key];
}
